import React, { useState } from 'react';

import { format } from 'date-fns';

import { LogoMicroUniverso } from '@componentes-mu/componentes-mu';

import styles from './styles.module.scss';

const MAX_LENGTH = 300;

interface MessageCardProps {
  sender: string;
  timestamp: string;
  message: string;
  isOwnMessage: boolean;
}

const MessageCard = ({ sender, timestamp, message, isOwnMessage }: MessageCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const displayMessage = message.length > MAX_LENGTH && !isExpanded
    ? message.substring(0, MAX_LENGTH) + '...'
    : message;

  return (
    <div className={`${styles.messageWrapper} ${isOwnMessage ? styles.ownMessageWrapper : styles.otherMessageWrapper}`}>

      <div className={styles.avatarContainer}>
        {isOwnMessage && (
          <div className={styles.avatar}>{sender.charAt(0)}</div>
        )}
      </div>

      <div className={styles.messageCard}>
        <div className={styles.header}>
          <div className={styles.senderInfo}>
            <span className={styles.senderName}>{sender}</span>
            <span className={styles.timestamp}>{format(new Date(timestamp), 'dd/MM/yyyy | HH:mm')}</span>
          </div>
        </div>
        <div className={styles.messageContent}>
          <p dangerouslySetInnerHTML={{ __html: displayMessage }}></p>
          {message.length > MAX_LENGTH && (
            <button onClick={toggleExpanded} className={styles.readMoreButton}>
              {isExpanded ? 'Ler menos' : 'Ler mais'}
            </button>
          )}
        </div>
      </div>

      <div className={styles.avatarContainer}>
        {!isOwnMessage && (
          <LogoMicroUniverso tipoLogo="largeLogoBlue" Altura="auto" className={styles.microuniversoLogo} />
        )}
      </div>

    </div>
  );
};

export default MessageCard; 